import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { fetchActivity } from "../lib/driveClient";

const LABELS = {
  upload_file: "Datei hochgeladen",
  download_file: "Datei heruntergeladen",
  delete_file: "Datei gelöscht",
  create_folder: "Ordner erstellt",
  create_artist: "Künstler angelegt",
  create_customer: "Kunde angelegt",
  login: "Login",
};

export default function DriveActivity() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActivity(200)
      .then(setRows)
      .catch((e) => toast.error(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <div className="flex items-center gap-3 mb-3 text-[10px] tracking-[0.4em] uppercase text-zinc-500 font-bold">
          <span className="block w-8 h-px bg-[#ff0033] shadow-[0_0_8px_#ff0033]" />
          Aktivität
        </div>
        <h1 className="font-display font-black uppercase tracking-tighter leading-none text-3xl md:text-4xl">Alle Events</h1>
      </motion.div>

      {loading ? (
        <div className="p-10 text-center text-sm text-zinc-500">Lade…</div>
      ) : rows.length === 0 ? (
        <div className="bg-[#0A0A0A] border border-white/[0.06] p-10 text-center text-sm text-zinc-500">Noch keine Events.</div>
      ) : (
        <div className="bg-[#0A0A0A] border border-white/[0.06] divide-y divide-white/[0.04]">
          {rows.map((r) => (
            <div key={r.id} data-testid={`activity-${r.id}`} className="p-4 md:px-6 flex items-center justify-between gap-4">
              <div className="flex items-center gap-4 min-w-0">
                <span className="red-led shrink-0" />
                <div className="min-w-0">
                  <div className="text-sm text-white truncate">
                    <span className="text-zinc-400">{LABELS[r.action] || r.action}</span>
                    {r.target_name && <span className="text-white ml-2">{`„${r.target_name}"`}</span>}
                  </div>
                  <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-600 mt-1">
                    {new Date(r.created_at).toLocaleString("de-DE")}
                  </div>
                </div>
              </div>
              <div className="text-[9px] tracking-[0.25em] uppercase text-zinc-600 shrink-0">
                {r.target_type || "–"}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
